export enum VossScheduledChangeStatus {
    Pending = 0,
    CompletedForUpcomingPeriod = 1,
    Completed = 2,
    Cancelled = 3,
}

export const VossScheduledChangeStatusText: Record<VossScheduledChangeStatus, string> = {
    [VossScheduledChangeStatus.Pending]: 'vossScheduledChangeStatus.pending',
    [VossScheduledChangeStatus.CompletedForUpcomingPeriod]: 'vossScheduledChangeStatus.completedForUpcomingPeriod',
    [VossScheduledChangeStatus.Completed]: 'vossScheduledChangeStatus.completed',
    [VossScheduledChangeStatus.Cancelled]: 'vossScheduledChangeStatus.cancelled',
};
